export default function prefix(name) {
  return `opentok/${name}`;
}
